import { IUserLogGroup } from 'bets.oddprovider.lib.common.ts/models'
import { ApiClientUtils } from 'fwork-jsts-common/src/apiClient'
import { FilterQuery } from 'mongoose'
import { useSnackbar } from 'notistack'
import * as React from 'react'
import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { DEFAULTGAP, RoutesNames } from '../../globals'
import { toggleLoading } from '../../redux/reducers/loadingBar.slice'
import { IUsersLogsGroupsState, usersLogsGroupsStateLoadFromApi } from '../../redux/reducers/usersLogsGroups.slice'
import { RootState } from '../../redux/store'
import { HeaderComponent } from '../common/header'
import { SearchInputComponent } from '../common/searchInput'
// import { TableComponent } from '../common/table'
// import { StyledListItemText, StyledTableCell, TableComponentClickRowProps, TableComponentSetCurrPageProps } from '../common/table/common'
import { StyledListItemText, StyledTableCell, TableComponent, TableComponentSetCurrPageProps } from 'fwork.react.apptemplate'

export const LogsClassificationsComponent = () => {
  const tableComponentSetCurrPageRef = React.useRef<TableComponentSetCurrPageProps>(() => { });
  const tableComponentSetCurrPage = tableComponentSetCurrPageRef.current

  const usersLogsGroupsState: IUsersLogsGroupsState = useSelector((state: RootState) => state.usersLogsGroupsState)
  const usersLogsGroups = [...usersLogsGroupsState.payload || []]
  const navigate = useNavigate()
  const { enqueueSnackbar } = useSnackbar()
  const dispatch = useDispatch<any>()
  const [searchText, setSearchText] = useState<string | undefined>()


  const loadUsersLogsGroups = async () => {
    dispatch(toggleLoading())
    const where: FilterQuery<IUserLogGroup> | undefined = searchText ? {
      name: { $regex: searchText, $options: 'i' }
    } : undefined

    dispatch(usersLogsGroupsStateLoadFromApi({
      where,
      onFinally: () => {
        dispatch(toggleLoading())

        if (tableComponentSetCurrPage)
          tableComponentSetCurrPage({
            page: 0
          })
      },
      onError: (msg) => {
        enqueueSnackbar(ApiClientUtils.getErrorMessage(msg), { variant: 'error' })
      }
    }))
  }

  return <>
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      boxSizing: 'border-box',
      paddingBottom: DEFAULTGAP
    }}>
      <HeaderComponent
        props={{
          style: {
            paddingInline: DEFAULTGAP
          }
        }}
        title='Classificação de logs'
        onRefreshClick={loadUsersLogsGroups}
        onAddClick={() => navigate(RoutesNames.logsClassification)}
      />

      <SearchInputComponent
        style={{
          marginInline: DEFAULTGAP,
          maxWidth: 500
        }}
        label='Pesquisar por nome'
        onChange={e => setSearchText(e.target.value)}
        onKeyUp={e => { if (e.key === "Enter") loadUsersLogsGroups() }}
        onIconClick={loadUsersLogsGroups}
      />

      <TableComponent
        wrapperProps={{ style: { padding: DEFAULTGAP, maxWidth: 'calc(100% - 10px)' } }}
        setCurrPageRef={tableComponentSetCurrPageRef}
        bodyList={usersLogsGroups}
        bodyRowBuilder={(userLogGroup: IUserLogGroup) => {
          return <StyledTableCell>
            <StyledListItemText
              primary={userLogGroup.name}
            />
          </StyledTableCell>
        }}
        rowProps={{
          onClickGetItem: (event: React.MouseEvent<HTMLTableRowElement, MouseEvent>, item: IUserLogGroup) => {
            navigate(RoutesNames.logsClassification.replace(':id', item?.id.toString()))
          }
        }}
      />
    </div>
  </>
}